module.exports = __webpack_public_path__ + "static/media/credit_card.09529f38.svg";